import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useToast } from 'src/shared/components/ui/use-toast';
import { useOrg } from 'src/shared/contexts/OrgContext';

type UpdateThreadStoreProps = {
  threadStoreId: string;
  valuesToApprove: Record<string, any>;
};

export function useMutateThreadStore() {
  const queryClient = useQueryClient();
  const { orgFetch } = useOrg();
  const { errorToast } = useToast();

  const updateThreadStore = useMutation({
    mutationFn: async ({ threadStoreId, valuesToApprove }: UpdateThreadStoreProps) => {
      const res = await orgFetch(`/api/v2/flows/thread-store/${threadStoreId}`, {
        method: 'PATCH',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          valuesToApprove,
        }),
      });

      if (!res.ok) {
        throw new Error('Failed to update thread store');
      }

      return await res.json();
    },
    onSuccess: (_, { threadStoreId }) => {
      queryClient.invalidateQueries({
        queryKey: ['thread-stores'],
      });

      queryClient.invalidateQueries({
        queryKey: ['thread-store', threadStoreId],
      });
    },
    onError: (error) => {
      console.error('Thread store update error:', error);
      errorToast('Failed to save changes');
    },
  });

  return {
    updateThreadStore,
  };
}
